




























































import { IRequisition, IRequisitionLine } from '@/models';
import { mapActions, mapGetters } from 'vuex';
import RequisitionDetail from '@/components/requisition/RequisitionDetail.vue';
import RequisitionDetailActivityCard from '@/components/requisition/RequisitionDetailActivityCard.vue';
import RequisitionStateCard from '@/components/requisition/RequisitionStateCard.vue';
import RequisitionDetailDrawer from '@/components/requisition/RequisitionDetailDrawer.vue';
import RequisitionLineFormDialog from '@/components/requisition/RequisitionLineFormDialog.vue';
import { ErrorManager } from '@/models/error';
import Snackbar from '@/mixins/snackbar';

export default Snackbar.extend({
  components: {
    RequisitionDetail,
    RequisitionDetailActivityCard,
    RequisitionLineFormDialog,
    RequisitionDetailDrawer,
    RequisitionStateCard
  },

  data: () => ({
    loading: false,
    lineItem: null as IRequisitionLine | null,
    isLineDialogActive: false,
    errorMessage: ''
  }),

  mounted() {
    // only fetch requisition if not available in store ("try-get-or-fetch")
    if (!this.requisition) {
      this.loading = true;
      this.fetchRequisition(this.requisitionId)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  },

  computed: {
    ...mapGetters({
      getRequisitionById: 'requisition/getRequisitionById'
    }),

    requisitionId(): number {
      return Number(this.$route.params.id);
    },

    requisition(): IRequisition | undefined {
      return this.getRequisitionById(this.requisitionId);
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  methods: {
    ...mapActions({
      fetchRequisition: 'requisition/fetchRequisition'
    }),

    routeBackToList(action: string) {
      this.$router.replace({ name: 'requisition-list' }).then(() => {
        this.createSnack({
          color: 'success darken-1',
          type: 'success',
          right: true,
          useBtn: false,
          msg: `Requisition ${action}`,
          btnText: 'Ok',
          timeout: 6000
        });
      });
    },

    openRequisitionDialog(lineItem: IRequisitionLine) {
      this.lineItem = lineItem;
      this.isLineDialogActive = true;
    }
  }
});
